// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ncTE","col":"styles_col__1utHz"};